import { Button } from 'react-bootstrap';
import React from 'react';

const AppButton = (props) => {

    return (
      <Button ref={props.fref} type={props.type || "button"} className={`btn_base ${props.className || ""}`} variant={props.variant} disabled={props.disabled} size={props.sm ? "sm" : ""} style={props.style} onClick={props.disabled ? () => {}: props.onPress} title={props.title} aria-label={props.ariaLabel}>
        {props.children}
        {props.label && <span style={props.style_label} className="btn_label">{props.label}</span>}
      </Button>
    );

}

export default AppButton
